import { Link } from "react-router-dom";
import { BrandMark } from "@/components/marketing/Navbar";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-gold/20 py-16">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="flex flex-col md:flex-row justify-between gap-12 mb-14">
          <div>
            <BrandMark />
            <p className="text-mist text-sm mt-6 max-w-xs leading-relaxed">
              Full-service IPR consultants — patents, trademarks, designs, copyrights
              and patent analytics, from first idea to granted right.
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-12 text-sm">
            <div className="flex flex-col gap-3">
              <p className="text-xs uppercase tracking-[0.25em] text-gold font-semibold mb-2">Explore</p>
              <a href="#services" className="text-mist hover:text-gold transition-colors">Practice Areas</a>
              <a href="#method" className="text-mist hover:text-gold transition-colors">Method</a>
              <a href="#about" className="text-mist hover:text-gold transition-colors">About</a>
              <a href="#faq" className="text-mist hover:text-gold transition-colors">FAQ</a>
            </div>
            <div className="flex flex-col gap-3">
              <p className="text-xs uppercase tracking-[0.25em] text-gold font-semibold mb-2">Clients</p>
              <Link to="/portal/login" className="text-mist hover:text-gold transition-colors">Client Portal</Link>
              <Link to="/portal/register" className="text-mist hover:text-gold transition-colors">Create Account</Link>
              <a href="#contact" className="text-mist hover:text-gold transition-colors">Request a Quote</a>
            </div>
            <div className="flex flex-col gap-3">
              <p className="text-xs uppercase tracking-[0.25em] text-gold font-semibold mb-2">Contact</p>
              <span className="text-mist">directors@claimspacelegaltech.com</span>
              <span className="text-mist">claimspacelegaltech.com</span>
              <span className="text-mist leading-relaxed">Signet 1, Unit No. 825, Premier Colony Ground, Kalyan, Thane, Mangaon — 421204</span>
            </div>
          </div>
        </div>
        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row justify-between gap-4 text-xs text-mist/70">
          <p>© {new Date().getFullYear()} ClaimSpace LegalTech Pvt Ltd. All rights reserved.</p>
          <p>Founded by Anita Patel &amp; Akash Yadav</p>
        </div>
      </div>
    </footer>
  );
}
